// @ts-strict-ignore
export default {
  required:
    ({ message }) =>
    (value) => {
      const defaultMessage = 'This field is required'
      return value || message || defaultMessage
    },
  minValue:
    ({ min, message }) =>
    (value) => {
      const parsedValue = parseInt(value, 10)
      const defaultMessage = `Please enter a value above ${min - 1}`
      return parsedValue >= min || message || defaultMessage
    },
  maxValue:
    ({ max, message }) =>
    (value) => {
      const parsedValue = parseInt(value, 10)
      const defaultMessage = `Please enter a value below ${max + 1}`
      return parsedValue <= max || message || defaultMessage
    },
  minLength:
    ({ min, message }) =>
    (value) => {
      const defaultMessage = `Please enter a value longer than ${min - 1} characters`
      return (value && `${value}`.length >= min) || message || defaultMessage
    },
  maxLength:
    ({ max, message }) =>
    (value) => {
      const defaultMessage = `Please enter a value shorter than ${max + 1} characters`
      return (value && `${value}`.length <= max) || message || defaultMessage
    },
  valueBetween:
    ({ min, max, message }) =>
    (value) => {
      const parsedValue = parseInt(value, 10)
      const defaultMessage = `Please enter a value between ${min} and ${max} (inclusive)`
      return (parsedValue <= max && parsedValue >= min) || message || defaultMessage
    },
  deposit:
    ({ message, getValues }) =>
    (value) => {
      const propertyValue = getValues('propertyValue')
      const parsedValue = parseInt(propertyValue.replace(/,/g, ''), 10)
      const depositValue = parseInt(value.replace(/,/g, ''), 10)

      if (!isNaN(parsedValue) && !isNaN(depositValue)) {
        if (depositValue > parsedValue) {
          return message
        }
      }
    },
  addressLookup:
    ({ message }) =>
    (value) => {
      const defaultMessage = 'This field is required'
      const addresses = JSON.parse(value)
      const enoughHistory = addresses.reduce(
        (previousValue, currentValue) => previousValue + parseInt(currentValue.yearsAtAddress, 10),
        0,
      )

      const errors = addresses
        .map((address) => {
          return (
            (address.buildingname === '' && address.number === '') ||
            address.posttown === '' ||
            address.postcode === ''
          )
        })
        .filter((address) => address)

      return (enoughHistory >= 3 && errors.length === 0) || message || defaultMessage
    },
  addressInput:
    ({ message }) =>
    (value) => {
      const defaultMessage = 'This field is required'
      const address = JSON.parse(value)

      const error =
        (address.buildingname === '' && address.number === '') ||
        address.posttown === '' ||
        address.postcode === ''

      return !error || message || defaultMessage
    },
}
